export enum WarningLevel {
  IMPORTANT = 'important',
  WARNING = 'warning',
}
